import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 

export default async function putUser(
    state,
    providerUuid,
    password = ""
) {
    const unHashedJwt = await checkJwt()    

    if(!unHashedJwt){
        logout()
    }
    
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/updateUser?providerUuid=' + providerUuid + "&userUuid=" + state.uuid, {
            method: 'put',
            headers: { 
                'Authorization' : unHashedJwt
            },
            data: {
                "oib": state.oib,
                "username": state.username,
                "password": state.password ? state.password : password,
                "email": state.email,
                "first_name": state.first_name,
                "last_name": state.last_name,
                "user_roles": ["POWERADMIN", "ADMIN"],
                "user_web_properties":  state.user_web_properties
            }      
        }).then(res => res)
        .catch(error => error.response.data.status === 401 ? logout() : error.response)
        );
}